import { Link } from 'react-router-dom'
import { NumericFormat } from 'react-number-format'
import { getCurrency } from 'utils/authService'
import s from './ContactSpendItem.scss'

const ContactSpendItem = ({ contact }) => {
  return (
    <div className={s.spendItemConatiner}>
      <div className={s.spendItem}>
        <span className={s.value}>
          <NumericFormat
            thousandSeparator
            allowNegative={false}
            value={contact.value || 0}
            prefix={getCurrency().symbol}
            displayType={'text'}
          />
        </span>
        <Link to={`/contacts/${contact.id}`} className={s.link}>
          {contact.contactName}
        </Link>
        <span>{contact.title}</span>
      </div>
    </div>
  )
}

export default ContactSpendItem
